import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Recepcion } from '../modelo/recepcion/recepcion.module';


@Injectable({
  providedIn: 'root'
})
export class OrdenService {

  constructor(private http: HttpClient) { }

  listarOrdenes(fecha: string )
  {

    return this.http.get(environment.apiUrlFlp+"buscarOrden/"+fecha); 
   }



  obtenerLote()
  {

    return this.http.get(environment.apiUrl+"lote/"); 
   }

   registrarRecepcion(recepciones: Recepcion[])
   {
 
     return this.http.put<string>(environment.apiUrl+"registrarRecepcion/",recepciones); 
    }
 


  listarRecepcion(idOrden: string )
  {

    return this.http.get(environment.apiUrl+"recepcionPorOrden/"+idOrden); 
   }

   
  detalleOrdenes(documentno: string )
  {

    return this.http.get(environment.apiUrlFlp+"buscarDetalle/"+documentno);
   }

}
